import SaleDetails from "../../components/SaleDetails/SaleDetails";

const Report = () => {
  return (
    <div className="single">
      <div className="singleContainer">
        <div className="bottom">
          <h1 className="title">SALES REPORT</h1>
          <SaleDetails />
        </div>
      </div>
    </div>
  ); 
};

export default Report;
